<template>
  <header>
    <div
    class="header-of-single-page center-items-top"
    :style="
    'background-image:url(' + 'images/banners/' + bgSrc + ')'"
    >
    <div class="description">
      <h1 class="text-center" >
        {{titleOfPage}}
      </h1>
      <p class="text-center">
        {{theDiscription}}
      </p>
    </div>
      <div class="fillter"></div>
    </div>
    <div class="curren-route-bar">
      <b-container>
        <i class="icon-location"></i>
        <!-- {{"الرئيسية " + "> " + getRouteName()}} -->
        <span>
          <b-nav-item to="/" >
          {{changeHomeWord()}}
          </b-nav-item>
        </span>
        <span v-for="(word, index) in getRouteName()" :key="word + 'nav'">
            <b-nav-item v-if="index == 0" :to="getRouteName()[0]">
              {{' > ' + word }}
            </b-nav-item>
            <b-nav-item v-if="index == 1" :to="getRouteName()[1]">
              {{' > ' + word }}
            </b-nav-item>
        </span>
      </b-container>
    </div>
  </header>
</template>
<script type="text/javascript">
// import {EnPath, ArPath} from './functions.js'
  export default {
    name:"PagesHeader",
    props:['bgSrc', 'titleOfPage', 'theDiscription'],
    data() {
      return {
        currentPath:''
      }
    },
    methods: {
      getRouteName() {
        // var route = this.$route.path.replace('ar', 'عربي')
        var finalroute = this.$route.path.split('/');
        finalroute.shift()
        finalroute.shift()
        return finalroute;
      },

      //home Word
      changeHomeWord() {
        if(localStorage.getItem('lang') == 'ar') {
          return 'الرئيسية'

        }else if(localStorage.getItem('lang') == 'en') {
          return 'Home'

        }
      }
    },
  }
</script>
